var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textual-marker",class:{ 'textual-marker--inverted': _vm.inverted }},[_c('span',{staticClass:"textual-marker__label"},[_vm._v(_vm._s(_vm.label))]),_c('ArrowIcon',{staticClass:"textual-marker__icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }